import React, {useRef } from "react";
import CssTransition from "../../component/layout/css-transition";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "../../component/input-field";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import { useDispatch } from "react-redux";
import { addBookingTemplateName } from "../../redux/actions/bookingtemplate";
import { sanitizeInput } from "../../utils";

const schema = yup.object({
  name: yup
    .string()
    .matches(/^[^\s]+(?:$|.*[^\s]+$)/, "Blank space not allowed in team name.")
    .max(
      50,
      "Booking template name have reached maximum limit of characters allowed."
    ),
});

export default function AddBookingNameModal({ id, modalOpen, setModalOpen }) {
  const modalContent = useRef(null);
  const { control, setValue, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const defaultValues = {
    name: "",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    dispatch(
      addBookingTemplateName(data.name, (res) => {
        if (res.message === "not existed") {
          reset({
            name: "",
          });
          setModalOpen(false);
          navigate("/booking/design/create");
        } else {
          swal({
            content: (
              <CustomeModal type="error" title="Error!" content={res.message} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      })
    );
  };
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white w-full overflow-auto max-w-xl max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="py-8 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              Add Booking Template Name
            </h3>
            <form class="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="name"
                defaultValue={defaultValues.name}
                control={control}
                render={({ field: {onChange, ...field}, formState }) => (
                  <div>
                    <InputField
                      {...field}
                      onChange={(e)=> {
                        const value = sanitizeInput(e.target.value);
                        setValue("name", value)
                      }}
                      type="text"
                      label="Booking Template Name"
                      placeholder="Enter Booking Template Name"
                      wrapperClass="my-5"
                      error={
                        Boolean(formState.errors?.name)
                          ? formState.errors?.name.message
                          : null
                      }
                      required
                    />
                  </div>
                )}
              />
              <div class="flex justify-end space-x-2">
                <button
                  type="button"
                  className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
                  onClick={() => {
                    setModalOpen(false);
                    reset({
                      name: "",
                      location: "",
                    });
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                  type="Submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
